/**
 * Open a signed document URL. Tablet WebViews often block `window.open` from button handlers.
 */
export function openDocumentUrl(url: string): void {
  const trimmed = url.trim();
  if (trimmed === "") return;
  const opened = window.open(trimmed, "_blank", "noopener,noreferrer");
  if (opened != null) return;
  const link = document.createElement("a");
  link.href = trimmed;
  link.target = "_blank";
  link.rel = "noopener noreferrer";
  document.body.appendChild(link);
  link.click();
  link.remove();
}
